var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgSuccess = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "none",
  viewBox: "0 0 28 28"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#success_svg__a)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#5ED0A4",
  fillRule: "evenodd",
  d: "M28 14c0 7.732-6.268 14-14 14S0 21.732 0 14 6.268 0 14 0s14 6.268 14 14m-8.358-4.242c.41.41.41 1.074 0 1.484l-7 7a1.05 1.05 0 0 1-1.484 0l-2.8-2.8a1.05 1.05 0 1 1 1.484-1.484l2.058 2.057 3.129-3.129 3.129-3.128a1.05 1.05 0 0 1 1.484 0",
  clipRule: "evenodd"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "success_svg__a"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 0h28v28H0z"
})))));
export default SvgSuccess;